import { types } from "mobx-state-tree"
import { withEnvironment } from "../extensions/with-environment"

const MessageModalModel = types.model("MessageModal", {
  visible: types.optional(types.boolean, false),
  extra: types.optional(types.frozen(), {}),
})

export const GlobalModalStoreModel = types
  .model("GlobalModalStore", {
    visible: types.optional(types.boolean, false),
    type: types.optional(types.string, ""),
    extra: types.optional(types.frozen(), {}),

    messageModal: types.optional(MessageModalModel, {}),
  })
  .extend(withEnvironment)
  .actions((self) => {
    const setModal = (data) => {
      const { visible, extra = {} } = data
      self.visible = visible
      self.extra = extra
    }

    const setMessageModal = (data) => {
      const { visible, extra = {} } = data
      self.messageModal = {
        visible,
        extra: extra || {},
      }
    }

    return {
      setModal,
      setMessageModal,
    }
  })
